import React from 'react'
import PropTypes from 'prop-types'

import _map from 'lodash/map'

// Components
import LocationSearchResult from './LocationSearchResult'

// Location Search results
export default function LocationSearchResults ({results, onSelectResult}) {
  return (
    <div data-test='LocationSearchResults'>
      {_map(results, (result) => (
        <LocationSearchResult result={result} onSelectResult={onSelectResult} />
      ))}
    </div>
  )
}

LocationSearchResults.propTypes = {
  results: PropTypes.arrayOf(PropTypes.object).isRequired,
  onSelectResult: PropTypes.func.isRequired,
}
